<template>
    <div class="input-address f -a-center -gutter-small">
        <input type="text"
               class="expand editable-input-text"
               id="{{ inputId }}"
               v-bind:class="inputClass"
               autocomplete="off"
               v-model="value">

        <button class="btn btn-default"
                @click.prevent="force"
                v-if="!isValid">
            Forcer
        </button>

        <div v-if="displayList"
            class="list-group">
            <a class="list-group-item"
               href="#"
               v-for="choice in choices"
               v-on:click.prevent="choose(choice)">
               {{ choice.formatted_address }}
            </a>
        </div>
    </div>
</template>

<style scoped
       lang="less">
    @import '~src/style/variables';

    .input-address {
        position: relative;
    }

    .list-group {
        position: absolute;
        top: 100%;
        left: @grid-gutter-width;
        right: @grid-gutter-width;
        transform: translate(0, (@grid-gutter-width / 2));
        z-index: 10;
    }

    .form-control {
        width: auto;
    }
</style>

<script type="text/ecmascript-6">
    import {asyncDebounce, d} from '../../utils';
    import {geocode} from '../../api/geocoding';

    const TRANSFERABLE_ATTRIBUTES = ['required', 'placeholder'];

    export default {
        props: {
            inputClass: {
                'default': ''
            },
            inputId: {
                'default': ''
            },
            address: {
                'default': undefined,
                twoWay: true
            },
            valid: {
                'default': false,
                twoWay: true
            }
        },
        data() {
            return {
                value: '',
                required: false,
                choices: []
            };
        },
        compiled() {
            const input = this.$el.querySelector('input');

            for (const attr of TRANSFERABLE_ATTRIBUTES) {
                if (this.$el.hasAttribute(attr)) {
                    input.setAttribute(attr, this.$el.getAttribute(attr));
                    this.$el.removeAttribute(attr);

                    if (attr === 'required') {
                        this.required = true;
                    }
                }
            }
        },
        computed: {
            displayList() {
                return this.address === undefined;
            },
            isValid() {
                return !this.value ||
                        d(() => this.value === this.address.formatted_address, false);
            },
            isHtmlValid() {
                return !!((this.required && !this.address) || !this.valid);
            },
            hasRequiredAttr() {
                return this.required || !this.isValid;
            }
        },
        watch: {
            value: asyncDebounce(async function () {
                if (this.address && this.address.formatted_address === this.value) {
                    return;
                }

                this.address = undefined;

                if (this.value.length > 3) {
                    try {
                        this.choices = (await geocode(this.value)).slice(0, 5);
                    } catch (ignored) {
                    }
                } else {
                    this.choices = [];
                }
            }),
            isHtmlValid(v) {
                const input = this.$el.querySelector('input');

                if (v) {
                    input.setCustomValidity('Vous n\'avez pas choisi d\'adresse valide');
                } else {
                    input.setCustomValidity('');
                }
            },
            isValid() {
                this.valid = this.isValid;
            },
            hasRequiredAttr(r) {
                const input = this.$el.querySelector('input');
                if (r) {
                    input.setAttribute('required', '');
                } else if (!r) {
                    input.removeAttribute('required');
                }
            }
        },
        methods: {
            choose(item) {
                this.address = item;
                this.value = item.formatted_address;
            },
            force() {
                this.address = {
                    formatted_address: this.value
                };
            }
        },
        ready() {
            if (this.address && this.address.formatted_address) {
                this.value = this.address.formatted_address;
            }
            this.valid = this.isValid;
        }
    };
</script>



// WEBPACK FOOTER //
// InputAddress.vue?23796732